module.exports = __webpack_public_path__ + "static/media/polygon.064392de.png";